import { type BaseSelection, type Editor, Range } from 'slate';
import type { Annotation, AnnotationKey } from '../../types/aha-editor';

export const LOCAL_ONLY_ANNOTATION_KEY = '_local_temp_annotation' as const;

export function getAnotationIdsInRange(
  editor: Editor,
  range: Range | BaseSelection
): AnnotationKey[] {
  const annotationsInRange: AnnotationKey[] = [];

  if (!Range.isRange(range)) return annotationsInRange;

  const annotationsObject = editor.metadata?.annotations;
  if (!annotationsObject) return annotationsInRange;

  const annotations: Annotation[] =
    Object.values(annotationsObject).filter(Boolean);
  for (const annotation of annotations) {
    const annotationRange = annotation.range.current;
    if (!annotationRange) continue;

    if (Range.intersection(annotationRange, range)) {
      annotationsInRange.push(annotation.key);
    }
  }

  // Nested annotations should also be considered within the range. For this, we check
  // if there's an intersection between non-selected annotations and any of
  // the directly selected ones.
  const nestedAnnotationIds: AnnotationKey[] = [];
  for (const annotation of annotations) {
    if (annotationsInRange.includes(annotation.key)) continue;

    for (const annotationId of annotationsInRange) {
      const annotationRange = annotation.range.current;
      if (!annotationRange) continue;

      const intersectionCandidate = annotationsObject[annotationId];
      if (!intersectionCandidate) continue;

      const candidateRange = intersectionCandidate.range.current;
      if (!candidateRange) continue;

      if (Range.intersection(annotationRange, candidateRange)) {
        nestedAnnotationIds.push(annotation.key);
      }
    }
  }

  return [...annotationsInRange, ...nestedAnnotationIds];
}
